<template>
  <div class="input-wrapper" :class="(selected !== null && selected[0] !== '') ? 'input--has--value' : ''">
    <label v-if="label" :for="id">{{label}}</label>
     <select
      :id="id"
      :type="type"
      :value="value"
      :name="name"
      :placeholder="placeholder"
      @change="$emit('input', $event.target.value)"
      :class="classes"
      >
        <option v-for="option in options" :value="option.value" :disabled="option.disabled" :selected="option.selected">{{ option.title }}</option>
      </select>
      <span class="input--arrow">
        <svg viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="arrow-bg" d="M90 45c0 24.853-20.147 45-45 45S0 69.853 0 45 20.147 0 45 0s45 20.147 45 45Z" fill="#7A7A7A" fill-opacity=".5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.78 32.982a3 3 0 0 1 4.238-.202L45 50.946 64.982 32.78a3 3 0 1 1 4.036 4.44L47.691 56.608a4 4 0 0 1-5.382 0L20.982 37.22a3 3 0 0 1-.202-4.238Z" fill="#fff"/></svg>
      </span>
  </div>
</template>

<script>

export default {
  name: 'Select',
  data: () => ({
    selected: null
  }),
  components: {
  },
  computed: {
  },
  props: {
    id: { type: String , required: false, default: null },
    type: { type: String , required: false, default: null },
    value: { type: String , required: false, default: null },
    label: { type: String , required: false, default: null },
    name: { type: String , required: false, default: null },
    placeholder: { type: String, required: false, default: null },
    classes: { type: String, required: false, default: null },
    required: { type: String, required: false, default: null },
    options: { type: Array, required: false, default: null },
  },
  mounted () {
  },
  created () {
  },
  watch: {
    // Watch for state changes
    options: {
      handler (state) {
        this.getSelected()
      },
      deep: true
    }
  },
  methods: {
    getSelected () {
      // Preselect values
      this.selected = this.options.filter(function(obj) {
        return obj.selected === true
      })
      .map(function(obj) {
        return obj.value
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../scss/global/includes";

.input-wrapper {
    width: 100%;
    max-width: 100%;
    display: block;
    position: relative;
    margin-bottom: 8px;
    color: $primary-grey;

    &.input--has--value {
      .input--arrow svg .arrow-bg  {
        fill: $primary-grey;
        fill-opacity: 1;
      }
      select {
        color: $primary-grey;
        border: 1px solid $primary-grey;
        background: $blue-15-opacity;
      }
    }
}

.input-wrapper label {
    color: $primary-grey;
    font-size: 14px;
    padding-bottom: 5px;
    display: block;
}

.input-wrapper select {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    outline: none;
    font-size: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid $divider-dark;
    color: $primary-grey;
    font-family: $font-light;
    border-radius: 2px;
    margin-bottom: 0px;
    padding: 16px 10px;
    display: block;
    width: 100%;
    outline: none;
    background: #FFFFFF;

    &:focus {
      // border: 1px solid $primary;
      // color: $primary;
    }

    @include placeholder {
      color: $placeholder;
    }
}

.input-wrapper .input--arrow {
    width: 18px;
    position: absolute;
    top: 8px;
    right: 8px;
}


</style>
